import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useArticlesStore } from '@/stores/articles';
import { useRoute, useRouter } from 'vue-router';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
import { ChevronDownIcon } from '@heroicons/vue/24/outline';
import { ref, watch } from 'vue';
import { useShortLengthsOverview } from '@/utils/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticlesMenu',
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const router = useRouter();
        const route = useRoute();
        const articlesStore = useArticlesStore();
        const isShortLengthsOverview = useShortLengthsOverview();
        const menuHierarchy = ref([]);
        watch(() => [articlesStore.stats, articlesStore.groups], async () => {
            if (!articlesStore.isLoadingStats && !articlesStore.isLoadingGroups) {
                const newMenuHierarchy = [];
                for (const articleGroup of articlesStore.groups) {
                    const groupParent = {
                        id: articleGroup.grouping,
                        name: articleGroup.groupingName,
                        children: [],
                    };
                    for (const articleGroupChild of articleGroup.children) {
                        groupParent.children.push({
                            id: articleGroupChild.articleGroup,
                            name: articleGroupChild.articleGroupName,
                            queryName: `articleGroup`,
                        });
                    }
                    if (groupParent.children.length > 0) {
                        newMenuHierarchy.push(groupParent);
                    }
                }
                newMenuHierarchy.push({
                    id: 'remainders',
                    name: $t(`Short lengths`),
                    isLink: true,
                    class: ['mt-3'],
                });
                const materialsParent = {
                    id: 'material',
                    name: $t(`Material`),
                    children: [],
                    class: ['mt-3'],
                };
                for (const [materialId, materialName] of Object.entries(articlesStore.stats.materialName)) {
                    materialsParent.children.push({
                        id: materialId,
                        name: materialName,
                        queryName: `material`,
                    });
                }
                newMenuHierarchy.push(materialsParent);
                const shapesParent = {
                    id: 'shape',
                    name: $t(`Shape`),
                    children: [],
                };
                for (const [shapeId, shapeName] of Object.entries(articlesStore.stats.shapeName)) {
                    shapesParent.children.push({
                        id: shapeId,
                        name: shapeName,
                        queryName: `shape`,
                    });
                }
                newMenuHierarchy.push(shapesParent);
                menuHierarchy.value = newMenuHierarchy;
            }
        }, {
            immediate: true,
        });
        const itemsRefs = ref([]);
        watch(() => route.query, () => {
            const articleGrouping = route.query?.articleGrouping;
            if (articleGrouping) {
                for (const { id, element, isOpen } of itemsRefs.value) {
                    if ((id === articleGrouping && !isOpen) || (id !== articleGrouping && isOpen)) {
                        element.$el.click();
                    }
                }
            }
        });
        const __returned__ = { $t, router, route, articlesStore, isShortLengthsOverview, menuHierarchy, itemsRefs, get Disclosure() { return Disclosure; }, get DisclosureButton() { return DisclosureButton; }, get DisclosurePanel() { return DisclosurePanel; }, get ChevronDownIcon() { return ChevronDownIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
